import { render, staticRenderFns } from "./BookingDirection.vue?vue&type=template&id=104f5e31&scoped=true"
import script from "./BookingDirection.vue?vue&type=script&lang=js"
export * from "./BookingDirection.vue?vue&type=script&lang=js"
import style0 from "./BookingDirection.vue?vue&type=style&index=0&id=104f5e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f5e31",
  null
  
)

export default component.exports